"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("./util");
function getVariablesOfferConfirmation(move, consultant) {
    return {
        kunde: util_1.getAddressVariables(move.customer),
        beladestelle: move.loadingAddresses.length > 0
            ? move.loadingAddresses.map((ba) => ba.city).join("/")
            : move.customer.city,
        entladestelle: move.unloadingAddresses.map((ea) => ea.city).join("/"),
        datum: move.loadingDates
            .map((d) => util_1.formatDate(d.date))
            .filter((d) => !!d)
            .join(" / "),
        zeitraum: move.loadingDates
            .map((d) => util_1.ensureDate(d.date))
            .filter((d) => !!d)
            .map((d) => util_1.formatTimespan(d, 30))
            .join(" / "),
        barzahlung: move.paymentMethod === "cash",
        unterschrift: util_1.getSignature(consultant),
        packmaterialAnlieferungDatum: move.loadingDates
            .map((d) => util_1.formatDate(d.packingMaterialDate))
            .filter((d) => !!d)
            .join(" / ") || 0,
    };
}
exports.default = getVariablesOfferConfirmation;
//# sourceMappingURL=offerConfirmation.js.map